"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.Title = exports.Name = exports.Link = exports.Icon = exports.DropdownCreditsContainer = exports.CreditsHeading = exports.ContentCredits = exports.Content = exports.Container = exports.Chevron = exports.Category = exports.Bold = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _typography = require("@titelmedia/bricks-theme/lib/utilities/typography");
var _layout = require("@titelmedia/bricks-theme/lib/utilities/layout");
var _breakpoints = require("@titelmedia/bricks-theme/lib/variables/breakpoints");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const fadeOut = (0, _styledComponents.keyframes)`
  0% {
    opacity: 0.7;
  }
  100% {
    opacity: 0.2;
  }
`;
const Content = _styledComponents.default.div`
  margin-bottom: 2px;
  display: flex;
`;
exports.Content = Content;
const DropdownCreditsContainer = _styledComponents.default.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: 2rem;

  cursor: pointer;
`;
exports.DropdownCreditsContainer = DropdownCreditsContainer;
const CreditsHeading = _styledComponents.default.h3`
  ${(0, _typography.setFont)({
  headline: true
})}
  text-transform: uppercase;
`;
exports.CreditsHeading = CreditsHeading;
const Wrapper = _styledComponents.default.div`
  ${(0, _layout.setContainer)({
  size: 'lg'
})}
`;
exports.Wrapper = Wrapper;
const Container = _styledComponents.default.div`
  ${(0, _layout.setContainer)({
  size: 'sm'
})}
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 2rem;

  max-height: 0;
  overflow: hidden;
  transition: max-height 0.2s;
`;
exports.Container = Container;
const ContentCredits = _styledComponents.default.div`
  padding: 75px 20px 20px;

  @media (min-width: ${_breakpoints.BREAKPOINTS.md}px) {
    padding-left: 60px;
  }

  @media (min-width: ${_breakpoints.BREAKPOINTS.xl}px) {
    padding-left: 120px;
  }
`;
exports.ContentCredits = ContentCredits;
const Category = _styledComponents.default.h3`
  font-weight: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  ${(0, _typography.setFont)({
  bold: true
})}
  ${(0, _typography.setFontSizes)({
  xs: '11px',
  sm: '13px'
})}
  text-transform: uppercase;
  margin: 16px 0;

  grid-column: 2 span;
`;
exports.Category = Category;
const Title = _styledComponents.default.p`
  margin: 0px 6px 0px 0px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  ${(0, _typography.setFont)({
  bold: true
})}
  ${(0, _typography.setFontSizes)({
  xs: '11px',
  sm: '13px'
})}
  line-height: 140%;
`;
exports.Title = Title;
const Name = _styledComponents.default.span`
  margin: 0px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: inherit;
  ${(0, _typography.setFont)({})}
  ${(0, _typography.setFontSizes)({
  xs: '11px',
  sm: '13px'
})}
  line-height: 140%;
`;
exports.Name = Name;
const Link = _styledComponents.default.a`
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: inherit;
  text-decoration: underline;
  text-underline-offset: 2px;
`;
exports.Link = Link;
const Bold = _styledComponents.default.strong`
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: 'univers-bold';
`;
exports.Bold = Bold;
const Icon = _styledComponents.default.svg.attrs({
  xmlns: 'http://www.w3.org/2000/svg',
  fill: 'none'
})``;
exports.Icon = Icon;
const Chevron = (0, _styledComponents.default)(Icon)`
  transform: rotate(90deg);
  width: 32px;
  height: 32px;
  opacity: 0.7;

  animation: 1s ${fadeOut} infinite alternate;
`;
exports.Chevron = Chevron;
//# sourceMappingURL=styles.js.map